import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import UpgradeModulesTable from './UpgradeModulesTable';
import { initiateModuleUpgrade } from '../../actions/UpgradeModulesActions';
import DefaultPageLayout from '../../components/DefaultPageLayout';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUpgradeModulesDataForTable } from '../../selectors/UpgradeModulesSelectors';

const UpgradeModulesPage = () => {
  const translateString = useTranslation();
  const title = translateString('Upgrade Modules');
  const modules = useSelector(getUpgradeModulesDataForTable);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadUpgradeModulesData = async () => {
      document.title = translateString('Upgrade Modules');
      setIsLoading(true);
      await dispatch(initiateModuleUpgrade());
      setIsLoading(false);
    };

    loadUpgradeModulesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DefaultPageLayout pageTitle={title}>
      <UpgradeModulesTable modules={modules} isLoading={isLoading} />
    </DefaultPageLayout>
  );
};

export default UpgradeModulesPage;
